module.exports = __webpack_public_path__ + "static/media/map-marker.c7d6b1b2.png";